<template>
  <div class="student-rank-topBar">
    <div class="btn-list">
      <el-button @click="back" size="small">返回</el-button>
      <el-button type="success" size="small" @click="derivedScore" v-hasPermi="'sc:graderank:export'">导出成绩</el-button>
      <el-button v-hasPermi="'sc:studentscorecomparison:export'" type="primary" v-if="examType == 'class'" size="small"
        @click="chartDialogShow">学生成绩对比</el-button>
      <!-- <search :placeholder="'请输入学生姓名'" @search="studentSearch" />
      <search :placeholder="'请输入学号'" @search="studentNumberSearch" /> -->
    </div>
    <div class="color-list">
      <div class="color-item">
        科目成绩：
        <div class="color-box" :style="{ backgroundColor: color1 }"></div>
      </div>
      <div class="color-item">
        班级排名：
        <div class="color-box" :style="{ backgroundColor: color2 }"></div>
      </div>
      <div class="color-item">
        年级排名：
        <div class="color-box" :style="{ backgroundColor: color3 }"></div>
      </div>
    </div>
    <div class="select-list">
      <el-select v-model="selectCourseList" multiple placeholder="请选择对比科目" @change="selectCourse" size="small">
        <el-option v-for="item in courseList" :key="item.courseId" :label="item.courseName" :value="item.courseId">
        </el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
import search from "@/components/search/search.vue";
export default {
  props: ["examType", "studentList", "courseList"],
  components: { search },
  data() {
    return {
      selectCourseList: [], // 选中的科目
      color1: "#e21918",
      color2: "#0066cc",
      color3: "#008000",
    };
  },
  methods: {
    back() {
      this.$emit('back');
    },
    chartDialogShow() {
      this.$emit("chartDialogShow", true);
    },
    studentSearch(e) { },
    studentNumberSearch(e) { },
    selectCourse(e) {
      // console.log("选中的科目切换==>", e);
      this.$emit("selectCourseChange", e);
    },
    derivedScore() {
      this.$emit("derivedScore");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./studentRankTopBar.scss";
</style>